import * as actions from "store/actions/nfse/edit";
import IUser from "Types/INFSe";
import dayjs from "dayjs";

export interface NFSeEditState extends IUser {
	loading: boolean;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: NFSeEditState = {
	loading: false,
	value: "",
	code: "",
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.GET_NFSE: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.GET_NFSE_SUCCESS: {
			return {
				...initialState,
				...payload,
				item: payload
			};
		}
		case actions.GET_NFSE_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.EDIT_NFSE: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.EDIT_NFSE_SUCCESS: {
			return {
				...initialState,
				item: payload
			};
		}
		case actions.EDIT_NFSE_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
